import React, {Component} from 'react';
import AuthenticatedTemplate from "../../Components/Templates/Authenticated/index";
import { Dimmer, Card, Grid, Icon } from 'tabler-react';
import CreditCardInfo from '../../Components/CreditCardInfo';
import SuspendSubscriptionCard from '../../Components/SuspendSubscriptionCard';
import CancelSubscriptionCard from '../../Components/CancelSubscriptionCard';
import InvoicesListCard from '../../Components/InvoicesListCard';
import SubscriptionIdCard from '../../Components/SubscriptionIdCard';
import fetch from '../../support/fetch';
import ActivityIndicator from '../../Components/Playgrond/ActivityIndicator';
import { statusDescription } from '../../support/subscription';
import CouponManager from '../../Components/CouponManager';
import { Link } from 'react-router-dom';

import './index.sass';
import CancelAndUpgradeSubscriptionCard from '../../Components/CancelAndUpgradeSubscriptionCard';

class SubscriptionDetails extends Component {

    state = {
        showLoader: true,
        subscription: null
    };

    fetchSubscription = id => {
        fetch.obj({
            query: `query GetSubscriptionById ($id: ID!) {
              subscription (
                id: $id
              ) {
                id
                  status
                  status_color
                  payment_method
                  amount
                  created_at
                  plan {
                    name
                  }
                  coupon {
                    code
                  }
                  invoices {
                    id
                    amount
                    canceled
                    refunded
                    statusCode
                    statusDescription
                    created_at
                  }
              }
            }`,
            variables: {
                id: id
            }
        })
        .then(res => {
            if(res.data.hasOwnProperty('subscription')) {
                this.setState({
                    subscription: res.data.subscription,
                    showLoader: false
                });
                //console.log('subscription: ',res.data.subscription);
            }
        });
    };

    componentDidMount = () => {
        const {match} = this.props;
        this.fetchSubscription(match.params.id);
    };

    render = () => {

        const {subscription} = this.state;

        let statusIcon;
        let statusBackgroundColor = 'lightgrey';

        if (subscription && subscription.status_color) {
            statusIcon = subscription.status !== 'ACTIVATED' ? 'alert-triangle' : 'check';
            statusBackgroundColor = subscription.status_color;
        }

        const options = () => {
            return (
                <React.Fragment>
                    <a href="#" className="btn btn-primary">Aplicar</a>
                </React.Fragment>
            );
        };

        return (
            <AuthenticatedTemplate title="Detalhes da Assinatura">
                <Grid.Row className="subscription-insights">
                    <Grid.Col md={3}>
                        <div className="subscription-status active text-uppercase" style={{background: statusBackgroundColor}} >
                            <Icon name={statusIcon} /><br />
                            { subscription && statusDescription[subscription.status] }
                            { !subscription && <ActivityIndicator width="15" height="15" /> }
                        </div>
                    </Grid.Col>

                    {/*<Grid.Col md={3}>*/}
                        {/*<div className="divider">*/}
                            {/*<h6 className="mb-0 mt-2">Próxima Cobrança</h6>*/}
                            {/*<span className="lead">25/02/2018</span>*/}
                        {/*</div>*/}
                    {/*</Grid.Col>*/}

                    <Grid.Col  md={6}>
                        <h6 className="mb-0 mt-2">Valor do Plano</h6>
                        <span className="lead">
                            {subscription && 'BRL ' + subscription.amount.toFixed(2)}
                            { !subscription && <ActivityIndicator width="15" height="15" /> }
                        </span>
                    </Grid.Col>
                </Grid.Row>

                <SubscriptionIdCard id={this.props.match.params.id} />

                {
                    subscription && subscription.status === 'CANCELED' &&
                    <Card  className='alert-danger'>
                        <Card.Body>
                        Esta assinatura, está cancelada. Para renovar ou retornar ao Ooppah, você precisa 
                        criar uma nova assinatura clicando&nbsp;
                        <Link to={'/subscriptions/new'}>
                            aqui
                        </Link>
                        .<br /> Essa assinatura cancelada 
                        permanecerá visível apenas para fins de histórico.
                        </Card.Body>
                    </Card>
                }

                <h4 className="mt-4 mb-6 pl-4">Plano Contratado</h4>

                <Grid.Row>

                    <Grid.Col width="12" md="6">
                        <Card>
                            <Dimmer loader active={this.state.showLoader}>
                                <Card.Body>
                                    <Grid.Row>
                                        <Grid.Col className="mb-5">
                                            <h6 className="mb-1">
                                                Plano
                                            </h6>
                                            <span className="lead">
                                                {subscription && subscription.plan.name}
                                            </span>
                                            <br/>
                                            {/* 
                                            <a
                                                href="https://ooppah.zendesk.com/hc/pt-br/requests/new"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="small text-primary"
                                            >solicitar alteração de plano</a>
                                            */}
                                        </Grid.Col>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Col>
                                            <h6 className="mb-1">Tipo de Cobrança</h6>
                                            <span className="lead">{subscription && subscription.payment_method}</span>
                                        </Grid.Col>
                                    </Grid.Row>
                                </Card.Body>
                            </Dimmer>
                        </Card>

                        {
                            subscription && subscription.status === 'ACTIVATED' &&
                            <CouponManager subscription={subscription} />
                        }
                    </Grid.Col>

                    <Grid.Col width="12" md="6">
                        <CreditCardInfo />
                    </Grid.Col>
                </Grid.Row>

                <hr/>

                <InvoicesListCard invoices={subscription && subscription.invoices} />

                <hr/>
                <h4 className="mt-4 mb-6 pl-4">Gerenciamento da Assinatura</h4>

                <Grid.Row>
                    <Grid.Col width={12} md={6}>
                        <CancelAndUpgradeSubscriptionCard subscription={subscription} />
                    </Grid.Col>
                    <Grid.Col width={12} md={6}>
                        <CancelSubscriptionCard subscription={subscription} />
                    </Grid.Col>
                </Grid.Row>

            </AuthenticatedTemplate>
        );
    };
}

export default SubscriptionDetails;